import { editor } from 'monaco-editor-core';
import IStandaloneThemeData = editor.IStandaloneThemeData;

export const LUCENE_THEME: IStandaloneThemeData = {
  base: 'vs',
  inherit: true,
  rules: [
    {
      token: 'keyword',
      foreground: '#366EB2',
    },
    {
      token: 'string',
      foreground: '#922227',
    },
    {
      token: 'number',
      foreground: '#00A19B',
    },
    {
      token: 'operator',
      foreground: '#7F7F7F',
    },
  ],
  colors: {
    'editor.foreground': '#000000',
  },
};

export const SQLITE_THEME: IStandaloneThemeData = {
  base: 'vs',
  inherit: true,
  rules: [
    {
      token: 'keyword',
      foreground: '#366EB2',
    },
    {
      token: 'string',
      foreground: '#922227',
    },
    {
      token: 'number',
      foreground: '#00A19B',
    },
    {
      token: 'operator',
      foreground: '#8D8D8D',
    },
    {
      token: 'string.sql',
      foreground: '#922227',
    },
    {
      token: 'operator.sql',
      foreground: '#8D8D8D',
    },
    {
      token: 'predefined.sql',
      foreground: '#366EB2',
    },
    { token: '', foreground: '#333333', background: '#fffffe' },
  ],
  colors: {
    'editor.foreground': '#333333',
  },
};

export const YARA_THEME: IStandaloneThemeData = {
  base: 'vs',
  inherit: true,
  rules: [
    {
      token: 'keyword',
      foreground: '#366EB2',
    },
    {
      token: 'keyword.type',
      foreground: '#366EB2',
    },
    {
      token: 'string',
      foreground: '#922227',
    },
    {
      token: 'number',
      foreground: '#00A19B',
    },
    {
      token: 'number.float',
      foreground: '#00A19B',
    },
    {
      token: 'number.hex',
      foreground: '#00A19B',
    },
    {
      token: 'number.octal',
      foreground: '#00A19B',
    },
    {
      token: 'number.binary',
      foreground: '#00A19B',
    },
    {
      token: 'operator',
      foreground: '#8D8D8D',
    },
    { token: '', foreground: '#333333', background: '#fffffe' },
  ],
  colors: {
    'editor.foreground': '#333333',
  },
};
